import React from 'react';

import SvgIcon from '../../SvgIcon/SvgIcon';
import etsyIcon from '../../../../icons/etsyIconTrd.svg';
import facebookIcon from '../../../../icons/facebookIconTrd.svg';

import classes from './ModalMessage.css';



const modalMessage = (props) => {
    return (
        <div className={classes.ModalMessage}>
            <h1>{props.message}</h1>
            <hr/>
            <p className={classes.FacebookText}>Follow us on Facebook to find out the results!</p>
            <div className={classes.FacebookIcon}>
                <SvgIcon icon={facebookIcon} url={"https://www.facebook.com/groups/DiverseMediumDesigns"} />
            </div>
            <p className={classes.EtsyText}>Check our Etsy store for in stock pins!</p>
            <div className={classes.EtsyIcon}>
                <SvgIcon icon={etsyIcon} url={"https://www.etsy.com/shop/codaraho?fbclid=IwAR2dq7Boz_gEMUycEig-WC_8WVsLQ0v3eK0U5a2KBKrO6iXWg4SSWYCKhTE"} />
            </div>
        </div>
    )
}

export default modalMessage;


// WEBPACK FOOTER //
// ./src/components/UI/TrdModalScreen/ModalMessage/ModalMessage.js